import { render, staticRenderFns } from "./PartnerBlock.vue?vue&type=template&id=f147a73c"
import script from "./partnerBlock.ts?vue&type=script&lang=js&external"
export * from "./partnerBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports